import { globals } from "./globals";
import { variants } from "./variants";
import { products } from "./products";

export const getters = {
  ...globals,
  ...products,
  ...variants,
};
